import { ProfileFormData } from "./ProfileFormData";

export class AddressFormInitial {
    addressLine1 = "";
    addressLine2 = "";
    city = "";
    state?: string;
    stateId?: number;
    postalCode = "";
    country?: string;
    countryId?: string;
    id?: number;
    syAddressId?: number; // Existing SIS address row (student references), so a re-save updates instead of adding
    relationshipToApplicant?: string;
    phoneNumber?: string;
    workNumber?: string;
    confirmPhoneNumber?: string; // Used for phone number confirmation (e.g., student references)
    firstName?: string;
    lastName?: string;
    email?: string;
}

export class HomeAddress {
    Addr1 = "";
    Addr2 = "";
    City = "";
    State?: string;
    stateId?: number;
    Zip = "";
    country?: string;
    SyCountryID?: string;
}
export class ShippingAddress {
    ShippingAddressStreet = "";
    ShippingAddressLine2 = "";
    ShippingAddressCity = "";
    ShippingAddressState?: string;
    stateId?: number;
    ShippingAddressPostalCode = "";
    ShippingAddressCountry?: string;
    SyCountryID?: string;
}

export class EmergencyContactAddress extends AddressFormInitial {}
export class EmployerAddress extends AddressFormInitial {}

export class AddressFormData extends ProfileFormData {
    constructor(_applicantId: number, _pageId: string) {
        super(_applicantId, _pageId);
    }
    HomeAddress?: HomeAddress;
    ShippingAddress?: ShippingAddress;
    SameAsHome?: boolean;

    // When JSON.stringify is called, this method will be used to produce a flat payload
    toJSON() {
        const ha = this.HomeAddress;
        const sa = this.ShippingAddress;
        return {
            applicantId: this.applicantId,
            pageId: this.pageId,
            Addr1: ha?.Addr1 ?? "",
            Addr2: ha?.Addr2 ?? "",
            City: ha?.City ?? "",
            State: ha?.State ?? "",
            stateId: ha?.stateId,
            Zip: ha?.Zip ?? "",
            country: ha?.country ?? "",
            SyCountryID: ha?.SyCountryID ?? ha?.country ?? undefined,

            ShippingAddressStreet: sa?.ShippingAddressStreet ?? "",
            ShippingAddressLine2: sa?.ShippingAddressLine2 ?? "",
            ShippingAddressCity: sa?.ShippingAddressCity ?? "",
            ShippingAddressState: sa?.ShippingAddressState ?? "",
            ShippingAddressstateId: sa?.stateId,
            ShippingAddressPostalCode: sa?.ShippingAddressPostalCode ?? "",
            ShippingAddressCountry: sa?.ShippingAddressCountry ?? "",
            ShippingAddressCountryId: sa?.SyCountryID ?? sa?.ShippingAddressCountry ?? undefined,

            SameAsHome: this.SameAsHome ?? false,
        };
    }
}
